export default __webpack_public_path__ + "static/media/project-group.d37da2b9.svg";